import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Page numbers for pagination controls (1-based current page).
 */
export function getPageNumbers(currentPage: number, totalPages: number) {
  const maxVisiblePages = 5
  const rangeWithDots: Array<number | string> = []

  if (totalPages <= maxVisiblePages) {
    for (let index = 1; index <= totalPages; index++) {
      rangeWithDots.push(index)
    }
  } else {
    rangeWithDots.push(1)

    if (currentPage <= 3) {
      for (let index = 2; index <= 4; index++) {
        rangeWithDots.push(index)
      }
      rangeWithDots.push('...', totalPages)
    } else if (currentPage >= totalPages - 2) {
      rangeWithDots.push('...')
      for (let index = totalPages - 3; index <= totalPages; index++) {
        rangeWithDots.push(index)
      }
    } else {
      rangeWithDots.push('...')
      for (let index = currentPage - 1; index <= currentPage + 1; index++) {
        rangeWithDots.push(index)
      }
      rangeWithDots.push('...', totalPages)
    }
  }

  return rangeWithDots
}
